import { get, post } from './../Config/config';

export const FileDownload = {
    get: (data) => get(`/leads/export`, { params: data }),
} 